'use client';

import { c as _c } from "react/compiler-runtime";
import { capitalizarPrimeiraLetra } from '@/shared/utils/text';
import type { MarcoNegociacao } from '../../../types/negociacaoMarcoTypes';
import { etiquetaAutoria } from '../../../utils/autoriaMarco';
import { aparenciaDoMarco, CLASSES_POR_TOM } from '../../../utils/marcoIcones';
import { dataDoMarco, horaDoMarco } from '../../../utils/marcoDataHora';
interface MarcoCardProps {
  marco: MarcoNegociacao;
  isLast: boolean;
}
export function MarcoCard(t0) {
  const $ = _c(45);
  const {
    marco,
    isLast
  } = t0;
  let t1;
  if ($[0] !== marco.tipo) {
    t1 = aparenciaDoMarco(marco.tipo);
    $[0] = marco.tipo;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    icone: Icone,
    tom
  } = t1;
  const classes = CLASSES_POR_TOM[tom];
  let t2;
  if ($[2] !== marco.ator.tipo) {
    t2 = etiquetaAutoria(marco.ator.tipo);
    $[2] = marco.ator.tipo;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const etiqueta = t2;
  let t3;
  if ($[4] !== marco.ator.nome || $[5] !== marco.ator.tipo) {
    const nomeDoUsuario = marco.ator.tipo === "USUARIO" ? marco.ator.nome?.trim() : null;
    t3 = nomeDoUsuario ? capitalizarPrimeiraLetra(nomeDoUsuario) : null;
    $[4] = marco.ator.nome;
    $[5] = marco.ator.tipo;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const nomeExibido = t3;
  let t4;
  if ($[7] !== isLast) {
    t4 = !isLast && <div className="bg-marco-trilho absolute top-4 left-[15px] h-[calc(100%+16px)] w-0.5 rounded-[1.5px]" aria-hidden="true" />;
    $[7] = isLast;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = `relative flex size-8 items-center justify-center rounded-full ${classes.fundo}`;
  const t6 = `size-5 ${classes.icone}`;
  let t7;
  if ($[9] !== Icone || $[10] !== t6) {
    t7 = <Icone className={t6} strokeWidth={1.5} aria-hidden="true" />;
    $[9] = Icone;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t5 || $[13] !== t7) {
    t8 = <div className={t5}>{t7}</div>;
    $[12] = t5;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t4 || $[16] !== t8) {
    t9 = <div className="relative w-8 shrink-0 self-stretch">{t4}{t8}</div>;
    $[15] = t4;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== marco.dataHora) {
    t10 = dataDoMarco(marco.dataHora);
    $[18] = marco.dataHora;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10) {
    t11 = <span className="text-marco-data text-[13px] leading-normal font-semibold">{t10}</span>;
    $[20] = t10;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== marco.dataHora) {
    t12 = horaDoMarco(marco.dataHora);
    $[22] = marco.dataHora;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t12) {
    t13 = <span className="text-marco-hora text-[12px] leading-normal font-normal">{t12}</span>;
    $[24] = t12;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t11 || $[27] !== t13) {
    t14 = <div className="flex w-[92px] shrink-0 flex-col gap-0.5 whitespace-nowrap">{t11}{t13}</div>;
    $[26] = t11;
    $[27] = t13;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== marco.titulo) {
    t15 = <h4 className="text-marco-titulo w-full text-[14px] leading-normal font-semibold">{marco.titulo}</h4>;
    $[29] = marco.titulo;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== etiqueta || $[32] !== nomeExibido) {
    t16 = etiqueta && <span className="font-medium">{etiqueta}{nomeExibido && ` por ${nomeExibido}`}</span>;
    $[31] = etiqueta;
    $[32] = nomeExibido;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  const t17 = etiqueta && " \xB7 ";
  let t18;
  if ($[34] !== marco.descricao || $[35] !== t16 || $[36] !== t17) {
    t18 = <p className="text-marco-data w-full text-[14px] leading-[1.4] font-normal">{t16}{t17}{marco.descricao}</p>;
    $[34] = marco.descricao;
    $[35] = t16;
    $[36] = t17;
    $[37] = t18;
  } else {
    t18 = $[37];
  }
  let t19;
  if ($[38] !== t15 || $[39] !== t18) {
    t19 = <div className="flex min-w-0 flex-1 flex-col gap-1 break-words">{t15}{t18}</div>;
    $[38] = t15;
    $[39] = t18;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  let t20;
  if ($[41] !== t14 || $[42] !== t19 || $[43] !== t9) {
    t20 = <div className="flex w-full items-start gap-4 py-3">{t9}{t14}{t19}</div>;
    $[41] = t14;
    $[42] = t19;
    $[43] = t9;
    $[44] = t20;
  } else {
    t20 = $[44];
  }
  return t20;
}